import { PanelGroupProps, PanelGroup as ReactResizablePanelGroup } from 'react-resizable-panels';

interface IPanelGroup extends PanelGroupProps {}

export default function PanelGroup({ children, ...rest }: IPanelGroup) {
  return <ReactResizablePanelGroup {...rest}>{children}</ReactResizablePanelGroup>;
}
